import { ACTION_LAUNCH_ASSIGNMENT, ACTION_OPENASSIGNMENT } from '../store/state/actions';
import EnvironmentInfo from '../environment-info';

import RouteParser from './route-parser';
import { getRestEndPoint } from './app-router';
import type { RouteOptionsParam } from './types';

/**
 * API to return proper semantic url by removing global parameters like portal, noPortal, debug
 * @param url Input url which should be sanitized by removing global query params
 * @returns Proper semantic url by removing global parameters like portal and noPortal
 */
export const getSemanticURLWithRelatedQueryParams = (url: string) => {
  if (url.indexOf('?') > 0) {
    const [pathName, queryParams] = url.split('?');
    const urlSearchParams = new URLSearchParams(queryParams);
    const paramsMap: any = new Map();
    for (const [key, value] of urlSearchParams) {
      if (key !== 'portal' && key !== 'noPortal' && key !== 'debug' && key !== 'activeTab') {
        paramsMap.set(key, value);
      }
    }

    const searchParamsString = new URLSearchParams(paramsMap).toString();
    return searchParamsString ? `${pathName}?${searchParamsString}` : pathName;
  }
  return url;
};

export const getAssignmentRouteInfo = (url: string, optionsParam?: RouteOptionsParam) => {
  const urlKeys = url.split('/');
  const assignmentIndex = urlKeys.indexOf('assignments');
  const assignmentPath = urlKeys.slice(assignmentIndex - 2).join('/');
  const assignmentID = urlKeys[urlKeys.length - 1];
  const restObj = getRestEndPoint(ACTION_OPENASSIGNMENT, { assignmentID });

  return {
    routeEndpoint: restObj?.restApi,
    requestType: restObj?.reqType,
    payload: { assignmentID },
    options: optionsParam,
    routeKey: ACTION_LAUNCH_ASSIGNMENT,
    urlPath: assignmentPath
  };
};

export const resolveRouteInfoParams = (url: string, optionsParam?: RouteOptionsParam) => {
  if (url.includes('/assignments')) {
    return getAssignmentRouteInfo(url, optionsParam);
  }
  return RouteParser.getEndPointInfo(url);
};

export const isNextGenLandingPageRouting = () => {
  const envInfo = EnvironmentInfo.environmentInfoObject?.pyExecutionRuntimeName;
  return envInfo === 'Infinity';
};
